var sw = require('js/lib/sw');
var $  = require('js/sw-jquery/sw-jquery');
var pollingInstanceActions = require('js/lib/actions/PollingInstances/actionTypes');

sw.on(sw.SW_ACTION_EVENT, function(action) {

  if (action.type === pollingInstanceActions.POLLING_STATUS_COMPLETED) {
    $("[data-sw-polling-instance-container]").remove();
  }

});

window.updatePage = function() {
  if(!(window.update_3DViewer || window.update_OverviewDetails || window.update_PrintabilitySummaries || window.update_baseModelURL)) {
    return;
  }

  var params = {
    modelFileId:            window.modelFileId,
    update_3d_viewer:       window.update_3DViewer,
    update_overview:        window.update_OverviewDetails,
    update_printability:    window.update_PrintabilitySummaries,
    processingMaterials:    window.printabilityProcessingMaterials,
    update_base_model_url:  window.update_baseModelURL
  };

  $.post("/model/file", params, function(response) {
    response = window.JSON.parse(response);

    if(response.printabilitySummaries) {
      window.updatePrintabilitySummary(response.printabilitySummaries);
    }

    if(response['3dViewerStatus']) {

      var status = response['3dViewerStatus'].status;

      if (status !== window.cacheViewerStatus) {
        window.cacheViewerStatus = status;

      }

      window.get3DViewer(response['3dViewerStatus']);
    }

    if(response.overviewDetails) {
      window.updateOverviewDetails(response.overviewDetails);
    }

    window.updatePageTimeOut = setTimeout(window.updatePage, 2500);
  });
};

$(document).ready(function() {
  sw.listenTo(sw, 'model-pose-saved', window.updatePage);
  window.updatePage();
});
